import * as CookieConsent from 'vanilla-cookieconsent';
import "vanilla-cookieconsent/dist/cookieconsent.css";

const CAT_ANALYTICS = "analytics";
const CAT_ADVERTISEMENT = "advertisement";
const CAT_FUNCTIONALITY = "functionality";
const CAT_SECURITY = "security";

const SERVICE_AD_STORAGE = 'ad_storage'
const SERVICE_AD_USER_DATA = 'ad_user_data'
const SERVICE_AD_PERSONALIZATION = 'ad_personalization'
const SERVICE_ANALYTICS_STORAGE = 'analytics_storage'
const SERVICE_FUNCTIONALITY_STORAGE = 'functionality_storage'
const SERVICE_PERSONALIZATION_STORAGE = 'personalization_storage'
const SERVICE_SECURITY_STORAGE = 'security_storage'

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}

function updateGtagConsent() {
    // Only update if gtag is available
    if (typeof gtag !== 'function') {
        window.dataLayer = window.dataLayer || [];
        window.gtag = function(){dataLayer.push(arguments);}
    }

    gtag('consent', 'update', {
        [SERVICE_ANALYTICS_STORAGE]: CookieConsent.acceptedService(SERVICE_ANALYTICS_STORAGE, CAT_ANALYTICS) ? 'granted' : 'denied',
        [SERVICE_AD_STORAGE]: CookieConsent.acceptedService(SERVICE_AD_STORAGE, CAT_ADVERTISEMENT) ? 'granted' : 'denied',
        [SERVICE_AD_USER_DATA]: CookieConsent.acceptedService(SERVICE_AD_USER_DATA, CAT_ADVERTISEMENT) ? 'granted' : 'denied',
        [SERVICE_AD_PERSONALIZATION]: CookieConsent.acceptedService(SERVICE_AD_PERSONALIZATION, CAT_ADVERTISEMENT) ? 'granted' : 'denied',
        [SERVICE_FUNCTIONALITY_STORAGE]: CookieConsent.acceptedService(SERVICE_FUNCTIONALITY_STORAGE, CAT_FUNCTIONALITY) ? 'granted' : 'denied',
        [SERVICE_PERSONALIZATION_STORAGE]: CookieConsent.acceptedService(SERVICE_PERSONALIZATION_STORAGE, CAT_FUNCTIONALITY) ? 'granted' : 'denied',
        [SERVICE_SECURITY_STORAGE]: CookieConsent.acceptedService(SERVICE_SECURITY_STORAGE, CAT_SECURITY) ? 'granted' : 'denied',
    });
}

CookieConsent.run({
    onFirstConsent: () => {
        updateGtagConsent();
    },
    onConsent: () => {
        updateGtagConsent();
    },
    onChange: () => {
        updateGtagConsent();
    },
    guiOptions: {
        consentModal: {
            layout: "box wide",
            position: "bottom left",
            equalWeightButtons: true,
            flipButtons: false
        },
        preferencesModal: {
            layout: "box",
            position: "right",
            equalWeightButtons: true,
            flipButtons: false
        }
    },
    categories: {
        necessary: {
            readOnly: true,
            services: {
                craft: {
                    label: "Craft CMS",
                    cookies: [
                        {
                            name: /^(Craft|CRAFT)/
                        }
                    ]
                },
                aws: {
                    label: "AWS/Content Delivery",
                    cookies: [
                        {
                            name: /^(Vw5_G|KHW_Oir|pscrb)/
                        }
                    ]
                }
            }
        },
        functionality: {
            readOnly: false,
            enabled: true,
            services: {
                hubspot: {
                    label: "HubSpot Forms",
                    cookies: [
                        {
                            name: /^(__hssc|__hssrc|__hstc|hubspotutk)/
                        }
                    ]
                },
                videoEmbeds: {
                    label: "Video Embeds (Zoom, Vimeo)",
                    cookies: [
                        {
                            name: /^(visitorId|vuid|player|cred|_zm|_zirm)/
                        }
                    ]
                }
            }
        },
        analytics: {
            enabled: true,  // Changed to true for opt-out model
            services: {
                googleAnalytics: {
                    label: "Google Analytics & Tag Manager",
                    cookies: [
                        {
                            name: /^(_ga|_gid|_gat|_ga_|GA1\.|GTM-)/
                        }
                    ]
                }
            }
        },
        marketing: {
            enabled: true,  // Changed to true for opt-out model
            services: {
                googleAds: {
                    label: "Google Ads & DoubleClick",
                    cookies: [
                        {
                            name: /^(_gcl|_gac|Secure-|APISID|DSID|HSID|IDE|NID|SAPISID|SID|SIDCC|SSID|__podscribe|SAPSID|_cfuvid)/
                        }
                    ]
                },
                facebook: {
                    label: "Facebook/Meta Pixel",
                    cookies: [
                        {
                            name: /^(_fb[cp])/
                        }
                    ]
                }
            }
        }
    },

    language: {
        default: "en",
        autoDetect: "browser",
        translations: {
            en: {
                consentModal: {
                    title: "This website uses cookies",
                    description: "We use cookies to improve your browsing experience, analyze site traffic, and personalize content. By continuing to use this site, you consent to our use of cookies.",
                    acceptAllBtn: "Accept all",
                    acceptNecessaryBtn: "Reject all",
                    showPreferencesBtn: "Manage preferences",
                    footer: "<a href=\"\/privacy\">Privacy Policy</a>"
                },
                preferencesModal: {
                    title: "Consent Preferences Center",
                    acceptAllBtn: "Accept all",
                    acceptNecessaryBtn: "Reject all",
                    savePreferencesBtn: "Save preferences",
                    closeIconLabel: "Close modal",
                    serviceCounterLabel: "Service|Services",
                    sections: [
                        {
                            title: "Cookie Usage",
                            description: "When you visit our website, we use cookies and similar technologies to collect information. These tools help our website function properly, enable enhanced features like search and social sharing, analyze site performance, and deliver personalized advertising across various platforms. The data collected helps us understand how visitors use our website and allows us to provide a better user experience. You can customize your cookie preferences below, though please note that blocking certain cookies may impact your experience on our website and limit the features we can offer."
                        },
                        {
                            title: "Strictly Necessary Cookies <span class=\"pm__badge\">Always Enabled</span>",
                            description: "These cookies are essential for the website's core functions and cannot be disabled. They include security tokens that help protect our website forms from potential attacks. For administrators, they also include session identifiers that maintain secure login state. These cookies don't store any customer information and are required for the website to operate properly.",
                            linkedCategory: "necessary"
                        },
                        {
                            title: "Functionality Cookies <span class=\"pm__badge\">Always Enabled</span>",
                            description: "Functionality cookies allow us to provide an enhanced experience on our website. These cookies help us remember your preferences, power our search features, and enable content sharing capabilities. They collect anonymous information to provide you with personalized features and a smoother browsing experience. Without these cookies, certain website features may not function properly.",
                            linkedCategory: "functionality"
                        },
                        {
                            title: "Analytics Cookies",
                            description: "Analytics cookies help us understand how visitors interact with our website by collecting anonymous information about site usage. These cookies track information such as which pages are most popular, how long visitors stay on our site, and how they navigate between pages. We use Google Analytics and other tools to measure traffic patterns and improve our website's performance. This data is collected in an anonymous form and helps us make informed decisions about content and site improvements.",
                            linkedCategory: "analytics"
                        },
                        {
                            title: "Advertisement Cookies",
                            description: "Advertisement cookies help us deliver relevant advertising content both on our website and across other platforms. These cookies collect information about your browsing habits and interests to make advertising more personalized and meaningful to you. They track which pages you visit and which links you click, allowing us to show you ads that match your interests. You can disable these cookies, though you may still see ads, but they won't be tailored to your interests.",
                            linkedCategory: "marketing"
                        },
                        {
                            title: "More information",
                            description: "For questions about our cookie policy or to learn more about how we use cookies and protect your privacy, please visit our <a href=\"\/privacy\">Privacy Policy</a> or contact us at [your privacy email address]."
                        }
                    ]
                }
            }
        }
    },
    disablePageInteraction: false
});

document.documentElement.classList.add('cc--darkmode');
